import { createRootRoute } from "@tanstack/react-router";
import { Outlet } from "@tanstack/react-router";

import MainLayout from "@/components/Layouts/MainLayout";

export const Route = createRootRoute({
  component: () => (
    <MainLayout>
      <Outlet />
    </MainLayout>
  ),
});
